import Helper from './Helper';

class MegatrendCard {
  constructor() {
    this.cards = Array.prototype.slice.call(document.querySelectorAll('.lc-megatrend-card'));

    if (this.cards.length) {
      this.eagerLoadImages();
      this.bindEvents();
    }
  }

  // Megatrend images are above-the-fold / large — don't wait for lazy observer
  eagerLoadImages() {
    Helper.loadImagesInContainer('.lc-megatrend-card');
  }

  bindEvents() {
    this.cards.forEach((card) => {
      const header = card.querySelector('.lc-megatrend-card__header');
      const openBtn = card.querySelector('.lc-megatrend-card__btn--open');
      const closeBtn = card.querySelector('.lc-megatrend-card__btn--close');

      if (!header) {
        return;
      }

      // Whole header (title + icon) toggles open/close
      header.addEventListener('click', (event) => {
        event.preventDefault();

        if (card.classList.contains('is-open')) {
          this.close(card, openBtn, closeBtn);
          return;
        }

        this.open(card, openBtn, closeBtn);
      });
    });
  }

  open(card, openBtn, closeBtn) {
    card.classList.add('is-open');

    if (openBtn) {
      openBtn.setAttribute('aria-expanded', 'true');
      openBtn.hidden = true;
    }

    if (closeBtn) {
      closeBtn.hidden = false;
      closeBtn.focus();
    }
  }

  close(card, openBtn, closeBtn) {
    card.classList.remove('is-open');

    if (closeBtn) {
      closeBtn.hidden = true;
    }

    if (openBtn) {
      openBtn.hidden = false;
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.focus();
    }
  }
}

export default MegatrendCard;
